<template>
  <div class="site-layout">
    <app-navbar></app-navbar>
    <div class="router-container">
      <app-points-container></app-points-container>
      <router-view />
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppNavbar from '@/components/Layout/AppNavbar.vue';
import AppFooter from '@/components/Layout/AppFooter.vue';
import AppPointsContainer from '@/components/Layout/AppPointsContainer.vue';

export default {
  name: 'site-layout',
  components: {
    AppNavbar,
    AppFooter,
    AppPointsContainer,
  },
};
</script>

<style lang="scss" scoped>
.app-navbar {
  z-index: 2;
}
.app-footer {
  margin-top: 48px;
}
.router-container {
  position: relative;
  padding-top: var(--navbar-height);
  min-height: 100vh;
  z-index: 1;
}

@media(max-width: 992px) {
  .router-container {
    padding-top: 0;
  }
}
</style>
